import React, { useEffect, useState } from "react";
import {
  ActivityIndicator,
  Text,
  View,
  useWindowDimensions,
} from "react-native";
import { useQuery } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import Header from "../components/Header";
import { getAllMatchesByAnalystId } from "../config/mainRequest";
import { FETCHED_ALL_MATCHES } from "../redux/actions/types";
import SelectTournament from "./SelectTournament";
import { Stack } from "@mui/material";

const Home = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);

  const { width } = useWindowDimensions();
  const isMobile = width < 850;

  const {
    loading,
    token,
    all_matches,
    analyst_id,
    isAdmin,
    analystName,
    accountRole,
    tabsAccessible,
  } = useSelector((state) => ({
    isAuthenticated: state.auth.isAuthenticated,
    login_error: state.auth.login_error,
    loading: state.auth.loading,
    m_error_msg: state.match.m_error_msg,
    all_matches: state.match.all_matches,
    analyst_id: state.auth.analyst_id,
    user: state.auth.user,
    token: state.auth.token,
    isAdmin: state.auth.isAdmin,
    analystName: state.auth.analystName,
    accountRole: state.auth.accountRole,
    tabsAccessible: state.auth.tabsAccessible,
  }));

  const [searchMatchId, setSearchMatchId] = useState();
  const [searchTournament, setSearchTournament] = useState();
  const [searchTeam, setSearchTeam] = useState();
  const [searchByAnalyzed, setSearchByAnalyzed] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const {
    data: _allMatches,
    isLoading: isLoadingMatches,
    isFetching: isFetching,
    isRefetching: isRefetching,
  } = useQuery({
    queryKey: [
      "allMatchesByAnalystId",
      page,
      searchMatchId,
      searchTournament,
      searchTeam,
      searchByAnalyzed,
      startDate,
      endDate,
    ],
    queryFn: () =>
      getAllMatchesByAnalystId({
        page,
        analyst_id,
        token,
        searchMatchId,
        searchTournament,
        searchTeam,
        searchByAnalyzed,
        startDate,
        endDate,
      }),
    keepPreviousData: true,
    select: (data) => {
      const allMatches = data;

      allMatches?.match_data?.data &&
        sessionStorage.setItem(
          "all_matches",
          JSON.stringify(allMatches?.match_data?.data)
        );
      return data;
    },
    onSuccess: (data) => {
      dispatch({
        type: FETCHED_ALL_MATCHES,
        payload: data?.match_data?.data,
      });
    },
    onError: (error) => {
      dispatch({
        type: FETCHED_ALL_MATCHES,
        payload: [],
      });
    },
  });

  // useEffect(() => {
  //   // dispatch(getAllMatches(analyst_id, token));
  //   dispatch({
  //     type: FETCHED_ALL_MATCHES,
  //     payload: _allMatches?.match_data?.data,
  //   });
  // }, [_allMatches, dispatch]);

  return (
    <View style={[styles.container]}>
      <Header username={analyst_id} tab="home" />
      {isLoadingMatches && (
        <View
          style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
        >
          <ActivityIndicator size="large" />
          <Text style={{ fontFamily: "Roboto", fontSize: 18, opacity: 0.7 }}>
            Fetching Matches
          </Text>
        </View>
      )}

      <Stack
        style={{
          position: "relative",
          overflow: "auto",
          width: "100%",
          paddingTop: 10,
        }}
      >
        {!isLoadingMatches && _allMatches ? (
          <SelectTournament
            isRefetching={isRefetching}
            count={_allMatches?.match_data?.count}
            matchList={_allMatches}
            isLoading={isLoadingMatches || isFetching || isRefetching}
            setPage={setPage}
            onPress={({
              page,
              searchMatchId,
              searchTournament,
              searchTeam,
              searchByAnalyzed,
              startDate,
              endDate,
            }) => {
              setSearchMatchId(searchMatchId);
              setSearchTournament(searchTournament);
              setSearchTeam(searchTeam);
              setSearchByAnalyzed(searchByAnalyzed);
              setStartDate(startDate);
              setEndDate(endDate);
              setPage(page);
            }}
          />
        ) : (
          !isLoadingMatches && (
            <View
              style={{
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Text
                style={{
                  fontFamily: "Roboto",
                  fontSize: isMobile ? 12 : 18,
                  opacity: 0.7,
                }}
              >
                Matches List Unavailable
              </Text>
            </View>
          )
        )}
      </Stack>
    </View>
  );
};

const styles = {
  container: {
    flex: 1,
    width: "100%",
    overflow: "hidden",
    justifyContent: "flex-start",
    alignItems: "center",
    // paddingTop: 70,
  },
};

export default Home;
